import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   max-width: 420px;
   width: 100%;
   display: flex;
   flex-direction: column;

   .textInput {
      margin-bottom: 10px;
   }
`;